import SDIcon from './SDIcon'

const IconCarbonEdit = (props) => (
  <SDIcon title='Edit' {...props}>
    <path d='M2 26H30V28H2z' />
    <path d='M25.4,9c0.8-0.8,0.8-2,0-2.8l-3.6-3.6c-0.8-0.8-2-0.8-2.8,0l-15,15V24h6.4L25.4,9z M20.4,4L24,7.6l-3,3L17.4,7 L20.4,4z M6,22v-3.6l10-10l3.6,3.6l-10,10H6z' />
  </SDIcon>
)

export default IconCarbonEdit
